import debug from '@persei/sentry-debug'
import * as Sentry from '@sentry/browser'

const log = debug('scheduling-front', Sentry)
export default log
